import React, { useMemo } from 'react';
import { Flex, Text } from "onefaceui-react-components";
import PropTypes from 'prop-types';

import {
  stopStatusIcons,
  clonedStopStatusIcons
} from 'react/utils/stopDetailsPopupBase64Icons';
import { Badge, StopHoverTitle } from './styles';
import { getResourceTo } from 'react/utils/utils';

const stopStatusDescriptions = {
  PENDING: 'Greenmile.Stop.IconDescription.pending',
  DELIVERED: 'Greenmile.Stop.IconDescription.completed',
  REDELIVERED: 'Greenmile.Stop.IconDescription.redelivery',
  UNDELIVERED: 'Greenmile.Stop.IconDescription.undeliverable',
  CANCELED: 'Greenmile.Stop.IconDescription.cancel',
  IN_PROGRESS: 'Greenmile.Stop.IconDescription.inProgress',
  PARTIALLY_DELIVERED: 'Greenmile.Stop.IconDescription.partiallyDelivered'
};

const StopHoverCardHeader = (props) => {
  const { stopData, isBlocked } = props;
  const { status, statusClass, cloneDate, step, key, description } = stopData;

  const getStatusByStatusClass = useMemo(() => {
    const completedClasses = [
      "onTime",
      "onTimeOffDay",
      "early",
      "earlyOffDay",
      "late",
      "lateOffDay",
      "noTimeWindow"
    ];

    if(completedClasses.includes(statusClass)) {
      return "DELIVERED";
    }

    if(statusClass === "canceled") {
      return "CANCELED";
    }

    return "PENDING";
  }, [statusClass]);

  const statusIcons = cloneDate ? clonedStopStatusIcons : stopStatusIcons;
  const iconStatusBase64 = statusIcons[status ?? getStatusByStatusClass];
  const stopStatusTitle =
    getResourceTo(stopStatusDescriptions[status ?? getStatusByStatusClass]);
  const actualTitle = getResourceTo('notificationPanel.actual');
  const sequenceTitle = getResourceTo('Stop.popup.plannedSequence');
  const badgetTitle = `${actualTitle} / ${sequenceTitle}`;

  return (
    <header>
      <Flex gap={4}>
        <Badge className={statusClass} title={badgetTitle}>
          <Text size="sm" type="light" weight="bold" asChild>
            <span>{step.total}</span>
          </Text>
          {!isBlocked && (
            <Text size="xs" type="light" weight="light" asChild>
              <span>/{step.actual}</span>
            </Text>
          )}
        </Badge>
        <StopHoverTitle flexDirection="column">
          <Text size="xs" weight="bold" asChild>
            <span>
              {key}: {description}
            </span>
          </Text>
          <Flex alignItems="center" gap={2}>
            <div
              style={{ background: `var(${iconStatusBase64})` }}
              alt={`Stop status Icon - ${status}`}
              className="icon-status"
            />
            <Text size="xxs" asChild>
              <span>{stopStatusTitle}</span>
            </Text>
          </Flex>
        </StopHoverTitle>
      </Flex>
    </header>
  );
};

StopHoverCardHeader.propTypes = {
  stopData: PropTypes.object.isRequired,
  isBlocked: PropTypes.bool.isRequired,
};

export default StopHoverCardHeader;
